// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application"

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import CharacterPickerController from "./character_picker_controller"
application.register("character-picker", CharacterPickerController)

import EquipmentPickerController from "./equipment_picker_controller"
application.register("equipment-picker", EquipmentPickerController)

import CardPickerController from "./card_picker_controller"
application.register("card-picker", CardPickerController)

import DeckController from "./deck_controller"
application.register("deck", DeckController)

import DeckFilterController from "./deck_filter_controller"
application.register("deck-filter", DeckFilterController)

import BannerCarouselController from "./banner_carousel_controller"
application.register("banner-carousel", BannerCarouselController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import CharacterSearchController from "./character_search_controller"
application.register("character-search", CharacterSearchController)

import EpiphanyModalController from "./epiphany_modal_controller"
application.register("epiphany-modal", EpiphanyModalController)

import ThemePickerController from "./theme_picker_controller"
application.register("theme-picker", ThemePickerController)

import EquipmentSearchController from "./equipment_search_controller"
application.register("equipment-search", EquipmentSearchController)

import EquipmentPanelController from "./equipment_panel_controller"
application.register("equipment-panel", EquipmentPanelController)

import EquipmentFilterController from "./equipment_filter_controller"
application.register("equipment-filter", EquipmentFilterController)

import EquipmentFilterOptionsController from "./equipment_filter_options_controller"
application.register("equipment-filter-options", EquipmentFilterOptionsController)

import CharacterPanelController from "./character_panel_controller"
application.register("character-panel", CharacterPanelController)

import CharacterFilterController from "./character_filter_controller"
application.register("character-filter", CharacterFilterController)

import CharacterFilterOptionsController from "./character_filter_options_controller"
application.register("character-filter-options", CharacterFilterOptionsController)

import PartnerPanelController from "./partner_panel_controller"
application.register("partner-panel", PartnerPanelController)

import PartnerFilterController from "./partner_filter_controller"
application.register("partner-filter", PartnerFilterController)

import PartnerFilterOptionsController from "./partner_filter_options_controller"
application.register("partner-filter-options", PartnerFilterOptionsController)

import PartnerSearchController from "./partner_search_controller"
application.register("partner-search", PartnerSearchController)

import CardSearchController from "./card_search_controller"
application.register("card-search", CardSearchController)

import EngravingSearchController from "./engraving_search_controller"
application.register("engraving-search", EngravingSearchController)

import CardFilterController from "./card_filter_controller"
application.register("card-filter", CardFilterController)

import CardIndexSearchController from "./card_index_search_controller"
application.register("card-index-search", CardIndexSearchController)

import CardFilterOptionsController from "./card_filter_options_controller"
application.register("card-filter-options", CardFilterOptionsController)

import CardPanelController from "./card_panel_controller"
application.register("card-panel", CardPanelController)

import CardKeywordController from "./card_keyword_controller"
application.register("card-keyword", CardKeywordController)

import CardEffectController from "./card_effect_controller"
application.register("card-effect", CardEffectController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)
